import React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

const RELATED_SLIDES_PATH = [
  'M11.25 1.875C12.0784 1.875 12.75 2.54657 12.75 3.375V9C12.75 9.82843 12.0784 10.5 11.25 10.5',
  'H6.75V15C6.75 15.1989 6.82907 15.3896 6.96973 15.5303C7.11038 15.6709 7.30109 15.75 7.5 15.75',
  'H11.25V15C11.25 14.1716 11.9216 13.5 12.75 13.5H21.75C22.5784 13.5 23.25 14.1716 23.25 15',
  'V20.625C23.25 21.4534 22.5784 22.125 21.75 22.125H12.75C11.9216 22.125 11.25 21.4534 11.25 20.625',
  'V17.25H7.5C6.90326 17.25 6.33114 17.0128 5.90918 16.5908C5.48722 16.1689 5.25 15.5967 5.25 15',
  'V10.5H2.25C1.42157 10.5 0.75 9.82843 0.75 9V3.375C0.75 2.54657 1.42157 1.875 2.25 1.875H11.25',
  'ZM12.75 20.625H21.75V15H12.75V20.625ZM2.25 9H11.25V3.375H2.25V9Z',
].join('');

const RELATED_SLIDES_SPARKLE_PATH = [
  'M18 1.875C18.3639 1.875 18.675 2.13672 18.7383 2.49512C18.9051 3.43981 19.255 4.13191 19.749 4.62598',
  'C20.2431 5.12004 20.9352 5.46995 21.8799 5.63672C22.2383 5.69996 22.5 6.01107 22.5 6.375',
  'C22.5 6.73893 22.2383 7.05003 21.8799 7.11328C20.9352 7.28005 20.2431 7.62996 19.749 8.12402',
  'C19.255 8.61809 18.9051 9.31019 18.7383 10.2549C18.675 10.6133 18.3639 10.875 18 10.875',
  'C17.6361 10.875 17.325 10.6133 17.2617 10.2549C17.0949 9.31019 16.745 8.61809 16.251 8.12402',
  'C15.7569 7.62996 15.0648 7.28005 14.1201 7.11328C13.7617 7.05003 13.5 6.73893 13.5 6.375',
  'C13.5 6.01107 13.7617 5.69996 14.1201 5.63672C15.0648 5.46995 15.7569 5.12004 16.251 4.62598',
  'C16.745 4.13191 17.0949 3.43981 17.2617 2.49512L17.2959 2.36523C17.4028 2.075 17.6815 1.875 18 1.875',
  'ZM18 4.80371C17.8052 5.12573 17.5769 5.42116 17.3115 5.68652C17.0462 5.95189 16.7507 6.1802 16.4287 6.375',
  'C16.7507 6.5698 17.0462 6.79811 17.3115 7.06348C17.5767 7.32865 17.8053 7.62357 18 7.94531',
  'C18.1947 7.62357 18.4233 7.32865 18.6885 7.06348C18.9536 6.79831 19.2486 6.56971 19.5703 6.375',
  'C19.2486 6.18029 18.9536 5.95169 18.6885 5.68652C18.4231 5.42116 18.1948 5.12573 18 4.80371Z',
].join('');

const RelatedSlidesIcon: React.FC<SvgProps> = ({ color = '#0F172A', ...props }) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <Path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d={RELATED_SLIDES_PATH}
    />
    <Path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d={RELATED_SLIDES_SPARKLE_PATH}
    />
  </Svg>
);

export default RelatedSlidesIcon;
